import React from "react";
import { Link } from "react-router-dom";
import { FaRegHeart, FaHeart, FaRegFileImage } from "react-icons/fa6";
import { RiReplyLine } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import { MdEmojiEmotions } from "react-icons/md";
import { GrSend } from "react-icons/gr";
import Moment from "react-moment";
import EmojiPicker from "emoji-picker-react";
import { handleErrorImg, handleFormatNumber } from "../../../../../service/utils/utils";
import config from "../../../../../configs/Configs.json";
import AVATAR_DEFAULT from "../../../../../images/avatar-default.jpg";

const { IMAGE_POST_PLACEHOLDER } = config;

function CommentItem({
    comment,
    index,
    userID,
    onLike,
    onDelete,
    onEdit,
    onReply,
    dataThisComment,
    onSubCommentChange,
    onSubCommentImageUpload,
    onDeleteSubCommentImage,
    onSubmitSubComment,
    showEmoji,
    onToggleEmoji,
    onEmojiClick,
    commentTextareaRef,
}) {
    // Parse comment content
    const htmlContent = comment.Content || "";
    const htmlWithNewline = htmlContent.replace(/<br\s*\/?>/gi, "\n");
    const plainText = htmlWithNewline.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ");

    // Extract quote
    let quoted = null,
        restHtml = htmlContent;
    if (plainText.startsWith("[QUOTE]") && plainText.includes("[/QUOTE]")) {
        const endIdx = plainText.indexOf("[/QUOTE]");
        quoted = plainText.substring(7, endIdx);
        const quotedLines = quoted.split("\n").filter((line) => line.trim() !== "");
        quoted = quotedLines.slice(0, 3).join("\n");
        if (quotedLines.length > 3) quoted += "\n...";
        const quoteHtmlEnd = htmlContent.indexOf("[/QUOTE]") + 8;
        restHtml = htmlContent
            .substring(quoteHtmlEnd)
            .replace(/^<p><br><\/p>/, "")
            .trim();
    }

    let shortQuote = null;
    if (quoted) {
        const quotedLines = quoted.split("\n").filter((line) => line.trim() !== "");
        shortQuote = quotedLines.slice(0, 3).join("\n");
        if (quotedLines.length > 3) shortQuote += "\n...";
    }

    return (
        <div className="mt-2 rounded-md h-auto">
            {/* Comment Header */}
            <div className="w-full py-2 px-1 backdrop:blur-md flex bg-[#1da57a] justify-between text-black">
                <Moment locale="VN" format="hh:mm DD/MM/YYYY" fromNow>
                    {`${comment?.CommentUpdateTime}+0700`}
                </Moment>
                <h3>#{index + 2}</h3>
            </div>

            <div className="border-x border-b border-solid border-white rounded-b-md overflow-hidden">
                {/* Author Info */}
                <div className="w-full border-b border-solid border-white p-4">
                    <div className="w-full flex justify-between items-center">
                        <Link to={`/profile/${comment?.UserName}`}>
                            <div className="flex justify-start items-center">
                                <img
                                    src={comment?.Avatar || AVATAR_DEFAULT}
                                    alt="avatar"
                                    className="w-16 h-16 aspect-square mr-3 object-cover"
                                    onError={(e) => handleErrorImg(e.target)}
                                />
                                <div className="w-full">
                                    <h1 className="text-sm font-medium">{comment?.FullName}</h1>
                                </div>
                            </div>
                        </Link>
                        <div>
                            {comment?.UserID === userID && (
                                <button
                                    className="hover:text-red-500"
                                    onClick={() => onDelete(comment?.CommentID)}
                                >
                                    Xóa
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                {/* Comment Content */}
                <div className="p-4">
                    {/* Quote */}
                    {shortQuote && (
                        <div
                            className="mb-2 p-2 rounded bg-gray-500 bg-opacity-40 italic text-sm"
                            style={{
                                opacity: 0.6,
                                pointerEvents: "none",
                                color: "#9CA3AF",
                                userSelect: "none",
                            }}
                        >
                            {shortQuote.split("\n").map((line, idx) => (
                                <div key={idx}>{line}</div>
                            ))}
                        </div>
                    )}

                    {/* Comment Text */}
                    <div
                        className="comment-content"
                        style={{
                            whiteSpace: "pre-line",
                            wordBreak: "break-word",
                            overflowWrap: "break-word",
                            wordWrap: "break-word",
                        }}
                        dangerouslySetInnerHTML={{ __html: restHtml || "" }}
                    />

                    {/* Comment Images */}
                    {Array.isArray(comment?.Photo) &&
                        comment.Photo.length > 0 &&
                        comment.Photo.map((img, idx) => (
                            <div key={idx} className="w-full aspect-video backdrop:blur-md bg-black/80 rounded-lg mt-2">
                                <img
                                    src={img || IMAGE_POST_PLACEHOLDER}
                                    alt="post"
                                    className="w-full h-full object-contain rounded-lg"
                                    onError={(e) => handleErrorImg(e.target)}
                                />
                            </div>
                        ))}
                    {Array.isArray(comment?.PhotoURL) &&
                        comment.PhotoURL.length > 0 &&
                        comment.PhotoURL.map((img, idx) => (
                            <div key={idx} className="w-full aspect-video backdrop:blur-md bg-black/80 rounded-lg mt-2">
                                <img
                                    src={img || IMAGE_POST_PLACEHOLDER}
                                    alt="post"
                                    className="w-full h-full object-contain rounded-lg"
                                    onError={(e) => handleErrorImg(e.target)}
                                />
                            </div>
                        ))}
                    {typeof comment?.PhotoURL === "string" && comment.PhotoURL && (
                        <div className="w-full aspect-video backdrop:blur-md bg-black/80 rounded-lg mt-2">
                            <img
                                src={comment.PhotoURL || IMAGE_POST_PLACEHOLDER}
                                alt="post"
                                className="w-full h-full object-contain rounded-lg"
                                onError={(e) => handleErrorImg(e.target)}
                            />
                        </div>
                    )}

                    {/* Comment Actions */}
                    <div className="pt-3 flex justify-between items-center">
                        {/* Like */}
                        <div className="flex gap-2 items-center text-md">
                            {!comment?.IsFavorited ? (
                                <FaRegHeart
                                    className="text-white cursor-pointer"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        onLike(comment?.CommentID);
                                    }}
                                />
                            ) : (
                                <FaHeart
                                    className="text-red-500 cursor-pointer"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        onLike(comment?.CommentID);
                                    }}
                                />
                            )}
                            {handleFormatNumber(comment?.FavoriteCount)}
                        </div>

                        {/* Edit & Reply Buttons */}
                        <div className="flex gap-2 items-center">
                            {/* Edited Label */}
                            {comment.CommentUpdateTime !== comment.CommentTime && (
                                <span className="text-xs italic text-yellow-400 ml-1">
                                    Đã chỉnh sửa lúc{" "}
                                    <Moment format="DD/MM/YYYY HH:mm">{`${comment.CommentUpdateTime}+0700`}</Moment>
                                </span>
                            )}

                            {/* Edit Button */}
                            {comment?.UserID === userID && (
                                <button
                                    className="flex items-center gap-1 text-sm font-medium hover:underline cursor-pointer hover:text-blue-500"
                                    onClick={() => onEdit(comment)}
                                    type="button"
                                >
                                    <FiEdit className="inline" /> Chỉnh sửa
                                </button>
                            )}

                            {/* Reply Button */}
                            <div
                                className="text-sm font-medium hover:underline cursor-pointer hover:text-blue-500"
                                onClick={() => onReply(comment)}
                            >
                                <RiReplyLine className="inline mr-1" /> Trả lời
                            </div>
                        </div>
                    </div>
                </div>

                {/* Sub-comments (Replies) */}
                {dataThisComment[comment?.CommentID]?.isShowID === comment?.CommentID && (
                    <>
                        {/* List Replies */}
                        <div className="border-t border-white p-4">
                            <div>
                                {Array.isArray(comment?.ReplyID) &&
                                    comment?.ReplyID.length > 0 &&
                                    comment?.ReplyID.map((itemReply, i) => (
                                        <div key={i}>
                                            <div className="mt-4 flex items-center mb-1">
                                                <div className="w-10 aspect-square mr-2 flex-shrink-0">
                                                    <img
                                                        src={itemReply?.Avatar || AVATAR_DEFAULT}
                                                        alt="avatar"
                                                        className="w-full h-full rounded-full"
                                                        onError={(e) => handleErrorImg(e.target)}
                                                    />
                                                </div>
                                                <div className="flex items-start justify-center flex-col px-3 pr-14 py-2 bg-[#222222] rounded-lg overflow-hidden">
                                                    <h3 className="text-sm font-medium">{itemReply?.FullName}</h3>
                                                    <div
                                                        className="whitespace-pre-line"
                                                        dangerouslySetInnerHTML={{ __html: itemReply?.Content || "" }}
                                                    />
                                                    {itemReply?.PhotoURL[0] && (
                                                        <div className="w-96 aspect-auto mt-2 object-contain rounded-lg overflow-hidden">
                                                            <img
                                                                alt="Imagecomment"
                                                                src={itemReply?.PhotoURL[0] || IMAGE_POST_PLACEHOLDER}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="text-xs flex gap-3 items-center">
                                                <Moment fromNow ago date={`${itemReply?.CommentUpdateTime}+0700`} />
                                                <p
                                                    className={`${itemReply?.IsFavorited && "text-blue-500"
                                                        } hover:text-blue-500 cursor-pointer${itemReply?.IsFavorited ? "text-blue-500" : "text-white"
                                                        }`}
                                                    onClick={() => onLike(itemReply?.CommentID)}
                                                >
                                                    {itemReply?.FavoriteCount ? itemReply?.FavoriteCount : ""}{" "}
                                                    {itemReply?.IsFavorited ? "Đã Thích" : "Thích"}
                                                </p>
                                                {itemReply?.UserID === userID && (
                                                    <button
                                                        className="hover:text-red-500"
                                                        onClick={() => onDelete(itemReply?.CommentID)}
                                                    >
                                                        Xóa
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </div>

                        {/* Reply Input */}
                        <div
                            className="p-4"
                            onClick={() => window.localStorage.setItem("ThisCommentID", comment?.CommentID)}
                        >
                            <div className="w-full flex relative">
                                <input
                                    type="text"
                                    className="rounded-l-full w-full py-2 px-4 flex-[6] bg-white text-black outline-none"
                                    placeholder="Bình luận bài viết..."
                                    value={dataThisComment[comment?.CommentID]?.Content || ""}
                                    onChange={(e) => onSubCommentChange(comment?.CommentID, e.target.value)}
                                    ref={commentTextareaRef}
                                />
                                <div className="flex-[1] flex z-50">
                                    {/* Emoji Button */}
                                    <div className="relative h-full bg-white text-blue-500 hover:text-white hover:bg-blue-500 flex-1 aspect-square flex items-center justify-center">
                                        <button type="button" className="flex" onClick={onToggleEmoji}>
                                            <MdEmojiEmotions className="size-7" />
                                        </button>
                                        {showEmoji && (
                                            <div
                                                className="fixed top-0 right-0 left-0 bottom-0 flex justify-center items-center z-50"
                                                onClick={onToggleEmoji}
                                            >
                                                <EmojiPicker
                                                    onClick={(e) => e.preventDefault()}
                                                    onEmojiClick={onEmojiClick}
                                                />
                                            </div>
                                        )}
                                    </div>

                                    {/* Image Button */}
                                    {!dataThisComment[comment?.CommentID]?.PhotoURL ? (
                                        <button className="flex-1 h-full aspect-square text-blue-500 bg-white my-auto text-xl hover:bg-blue-500 hover:text-white flex items-center justify-center relative">
                                            <input
                                                type="file"
                                                className="absolute top-0 right-0 left-0 bottom-0 opacity-0 cursor-pointer"
                                                onChange={(e) => onSubCommentImageUpload(e, comment?.CommentID)}
                                                value={dataThisComment[comment?.CommentID]?.PhotoURL ? "" : ""}
                                            />
                                            <FaRegFileImage />
                                        </button>
                                    ) : (
                                        dataThisComment[comment?.CommentID]?.base64Url && (
                                            <div className="flex-[2] h-full aspect-video overflow-hidden relative">
                                                <div
                                                    onClick={() => onDeleteSubCommentImage(comment?.CommentID)}
                                                    className="h-3 w-3 rounded-full bg-red-500 hover:bg-red-900 absolute top-0.5 right-0.5 cursor-pointer"
                                                ></div>
                                                <img
                                                    className="w-full h-full object-cover"
                                                    src={dataThisComment[comment?.CommentID]?.base64Url || IMAGE_POST_PLACEHOLDER}
                                                    alt="sub-comment-preview"
                                                />
                                            </div>
                                        )
                                    )}

                                    {/* Send Button */}
                                    <button
                                        onClick={() => onSubmitSubComment(comment?.CommentID)}
                                        className="flex-1 h-full aspect-square text-blue-500 bg-white hover:shadow-sm my-auto text-xl rounded-r-full hover:bg-blue-500 hover:text-white flex items-center justify-center"
                                    >
                                        <GrSend />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default CommentItem;

